import React from "react";

interface ISkeleton {
    style?: React.CSSProperties;
    className?: String;
}
const Skeleton = ({ className,style }: ISkeleton) => {
    return (
        <div className={`skeleton-loader ${className}`} style={style}></div>
    )
}

export default Skeleton